import ResursService from '@/services/ResursService'

export const namespaced = true

export const state = {
  page: 1,
  resursi: [],
  resursaUkupno: 0,
  resurs: {},
  filtri: {
    datum_od: '2020-01-01',
    datum_do: '2020-12-01'
  },
  perPage: 10
}
export const mutations = {
  ADD_RESURS(state, resurs) {
    state.resursi.push(resurs)
    state.resurs = resurs
  },
  SET_RESURS(state, resurs) {
    state.resurs = resurs
  },
  SET_RESURSA_TOTAL(state, resursaUkupno) {
    state.resursaUkupno = resursaUkupno
  },
  SET_RESURSI(state, resursi) {
    state.resursi = resursi
  },
  SET_PAGE(state, page) {
    state.page = page
  }
}
export const actions = {
  dodajResurs({ commit }, resurs) {
    // service
    return ResursService.dodajResurs(resurs).then(response => {
      commit('ADD_RESURS', response.data.podaci)
    })
  },
  izmeniResurs({ commit }, resurs) {
    // service
    return ResursService.izmeniResurs(resurs).then(response => {
      commit('SET_RESURS', response.data.podaci)
    })
  },
  dajResurse({ commit }, { type, perPage, page, filters }) {
    // service
    return ResursService.dajResurse(type, perPage, page, filters).then(
      response => {
        //console.log(response.headers)
        commit('SET_RESURSA_TOTAL', parseInt(response.headers['x-total-count']))
        commit('SET_RESURSI', response.data.podaci)
        commit('SET_PAGE', page)
      }
    )
  },
  dajResurs({ commit, getters }, id) {
    //console.log('test ' + id)
    // debugger
    var resurs = getters.dajResursById(id)
    //console.log('test ' + JSON.stringify(resurs))

    if (resurs && typeof resurs.elementi !== 'undefined') {
      // ovde je problem sto resurs.element nema url prop
      //commit('SET_RESURS', resurs)
      return ResursService.dajResurs(id).then(response => {
        //console.log(response.data.podaci)
        commit('SET_RESURS', response.data.podaci)
      })
    } else {
      // service
      return ResursService.dajResurs(id).then(response => {
        //console.log(response.data.podaci)
        commit('SET_RESURS', response.data.podaci)
      })
    }
  },
  obrisiResurs({ commit }, id) {
    return ResursService.obrisiResurs(id).then(response => {
      commit('SET_RESURS', response.data.podaci) // null
    })
  }
}
export const getters = {
  dajResursById: state => id => {
    //debugger
    return state.resursi.find(resurs => resurs.id === id)
  }
}
